module.exports = __webpack_public_path__ + "img/shushing_face.96dce9df.gif";